/**
 * FbResize JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class FbResize
 */
class FbResize {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.reParse = null;
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get all Facebook page embed elements.
        this.$fbPages = $( '.fb-page' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
        $( window ).resize( () => {

            // Ideally this would be set up with lodash debounce, but for some reason fb resizing does not work then.
            this.reParseFbPages();
        });
    }

    /**
     * Calculate width of all embedded Facebook pages and re-parse them.
     */
    reParseFbPages() {

        // Return early if Facebook SDK has not loaded.
        if ( ! ( 'FB' in window && typeof FB === 'object' && typeof FB.XFBML === 'object' ) ) {
            console.warn( 'Facebook SDK not loaded' );
            return;
        };

        // Set up the width attribute for all fb-page elements.
        this.$fbPages.each( ( index, element ) => {
            let width = $( element ).parent().width();

            // The width of the fb page can be max 500 (according to FB documentation).
            width = ( width > 500 ) ? 500 : width;
            $( element ).attr( 'data-width', width );
        });

        // Re-parse fb-pages.
        FB.XFBML.parse();
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = FbResize;



// WEBPACK FOOTER //
// ./assets/scripts/fb-resize.js